import { render, staticRenderFns } from "./PrivilegePicker.vue?vue&type=template&id=921d0786&"
import script from "./PrivilegePicker.vue?vue&type=script&lang=js&"
export * from "./PrivilegePicker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports